import { render, staticRenderFns } from "./clickRanking.vue?vue&type=template&id=523e05b0&scoped=true&"
import script from "./clickRanking.vue?vue&type=script&lang=js&"
export * from "./clickRanking.vue?vue&type=script&lang=js&"
import style0 from "./clickRanking.vue?vue&type=style&index=0&id=523e05b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e05b0",
  null
  
)

export default component.exports